exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.lh1[data-v-9bbe439c] {\n    line-height: 1;\n}\n", ""]);

// exports
